import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Typography,
} from '@mui/material';
import Page from '../../components/Layout/Page';
import LoginForm from './LoginForm';
import AuthService from '../../services/authService';
import useStyles from './styles';
import { ReduxState } from '../../types';
import { resetLocalAccounts, resetUserAccount } from '../../actions/userAccountAction';
import { resetAccountFarm } from '../../actions/accountFarmAction';

function LoginView() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const account = useSelector((state: ReduxState) => state.account);

  useEffect(() => {
    if (account?.user && AuthService.isAuthenticated()) {
      history.push('/inicio');
    }
  }, [account.user]);

  useEffect(() => {
    // These slices are persisted: a session that ended without logout() would otherwise hand
    // the previous user's account and farm to whoever logs in next.
    dispatch(resetUserAccount());
    dispatch(resetLocalAccounts());
    dispatch(resetAccountFarm());
  }, []);

  return (
    <Page
      className={classes.root}
      title="Login"
    >
      <Box className={classes.loginContainer}>
        <Box className={classes.loginFormContainer}>
          <Typography
            variant="h2"
            color="textPrimary"
          >
            Bienvienido a CDTEC IF
          </Typography>
          <Box mt={3} display='flex' justifyContent='center'>
            <LoginForm />
          </Box>
        </Box>
        <Box className={classes.imageContainer}>
          <img src='/img/new_login_background.png' alt="Login Background" className={classes.imageBackground} />
        </Box>
      </Box>
    </Page>
  );
}

export default LoginView;
